import {
  IPriceSnapshot,
  IPriceSnapshotData,
  IPriceSnapshotFieldError,
  IPriceSnapshotFieldErrorData
} from './pricesnapshot.types';

export class PriceSnapshot implements IPriceSnapshot {
  readonly id?: number;
  readonly description: string = '';
  readonly owner: string = '';
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  constructor(data?: IPriceSnapshotData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.description) {
        this.description = data.description;
      }

      if (data.owner) {
        this.owner = data.owner;
      }

      if (data.created_at) {
        this.created_at = data.created_at;
      }

      if (data.updated_at) {
        this.updated_at = data.updated_at;
      }
    }
  }

  validate(): boolean {
    return true;
  }
}

export class PriceSnapshotFieldError implements IPriceSnapshotFieldError {
  readonly id: string[] = [];
  readonly description: string[] = [];

  constructor(data?: IPriceSnapshotFieldErrorData) {
    if (data) {
      if (data.description) {
        this.description = data.description;
      }
    }
  }

  clearErrors(): void {
    this.description.splice(0, this.description.length);
  }

  static isPriceSnapshotFieldError(
    data: IPriceSnapshotFieldErrorData
  ): boolean {
    if (data.description && Array.isArray(data.description)) {
      return true;
    }

    return false;
  }
}
